const state={
    showBool:false,
    activeType:1,
    bShowClose:true,
}
const mutations={
    LOGINREGBOX_SHOW_HIDE(state,index){
        state.showBool=!state.showBool;
        if(index){
            state.activeType=index;
        }
    },
    LOGINREGBOX_SHOW_HIDE_CLOSE(state,bShow){
        //console.log("LOGINREGBOX_SHOW_HIDE_CLOSE", bShow);
        state.bShowClose=bShow;
    },
    LOGINREGBOX_TAB(state,index){
        state.activeType=index;
    }
}
const actions={
    upDataLoginRegShowBool({
        state,
        commit
    },index){
        commit('LOGINREGBOX_SHOW_HIDE',index)
    },
    loginBoxCardTab({
        state,
        commit
    },index){
        commit('LOGINREGBOX_TAB',index)
    },
    upDataLoginRegCloseBtnShowBool({
        state,
        commit
    },bShow){
        commit('LOGINREGBOX_SHOW_HIDE_CLOSE',bShow)
    },
}
const getters={}
export default{
    state,
    mutations,
    actions,
    getters
}